<template>
  <v-main class="main">
    <slot />
  </v-main>
</template>

<script>
export default {
  name: 'Plain',
}
</script>

<style>
.main {
  background: #e4e4e7;
}
</style>
